import {ActionsRow, DetailValue, FixedDropDownButton, Icon} from 'mc/lib';
import * as TypVyrovnaniSouhrn from 'mc/lib/api/gen/proxioapi/TypVyrovnaniSouhrn';
import {formatCurrency} from 'mc/lib/utils/commons';
import * as subjektFormatter from 'mc/lib/utils/subjektFormatter';
import PropTypes from 'prop-types';
import React, {PureComponent} from 'react';
import {connect} from 'react-redux';
import {CardBlock, Col, DropdownItem, Row} from 'reactstrap';
import {zrusitVyrovnani} from '../../actions/platbaActions';

class VyrovnaniCardBlock extends PureComponent {

    static propTypes = {
        platba: PropTypes.object.isRequired,
        vyrovnani: PropTypes.object.isRequired,
        readOnly: PropTypes.bool,
    };

    static defaultProps = {
        readOnly: false,
    };

    handleZrusit = () => {
        const {platba, vyrovnani, dispatch} = this.props;
        dispatch(zrusitVyrovnani(platba, vyrovnani.pripad));
    };

    renderActions() {
        return (
            <FixedDropDownButton color="action" noCaret title={<Icon icon="ellipsis-v"/>}>
                <DropdownItem type="button" onClick={this.handleZrusit}>Zrušit vyrovnání</DropdownItem>
            </FixedDropDownButton>
        )
    }

    render() {
        const {vyrovnani, readOnly} = this.props;
        const isTypFaktura = vyrovnani.typ === TypVyrovnaniSouhrn.FAKTURA;
        return (
            <CardBlock>
                <ActionsRow actions={!readOnly && isTypFaktura && this.renderActions()}>
                    <Row>
                        <Col xs={12} sm={6} lg={3}>
                            {isTypFaktura ? (
                                <DetailValue label="VS">
                                    {vyrovnani.pripad.vs}
                                </DetailValue>
                            ) : (
                                <DetailValue label="Číslo dokladu">
                                    {vyrovnani.cisloDokladu}
                                </DetailValue>
                            )}
                        </Col>
                        <Col xs={12} sm={6} lg={3}>
                            <DetailValue label="Subjekt">
                                {isTypFaktura && vyrovnani.pripad.subjekt
                                    && subjektFormatter.getUplnyNazev(vyrovnani.pripad.subjekt)}
                            </DetailValue>
                        </Col>
                        <Col xs={12} sm={6} lg={3}>
                            <DetailValue label="Částka vyrovnání">
                                {formatCurrency(vyrovnani.castkaVyrovnani)}
                            </DetailValue>
                        </Col>
                        <Col xs={12} sm={6} lg={3}>
                            <DetailValue label="Částka přeplatku">
                                {formatCurrency(vyrovnani.castkaPreplatek)}
                            </DetailValue>
                        </Col>
                    </Row>
                </ActionsRow>
            </CardBlock>
        );
    }

}

export default connect()(VyrovnaniCardBlock);
